export const CAROUSEL_STYLES = {
  root: "relative w-full h-full",
  content: {
    container: "overflow-hidden h-full",
    inner: "flex h-full",
    innerVertical: "flex-col h-full",
  },
  item: {
    base: "relative min-w-0 shrink-0 grow-0 basis-full h-full",
  },
  button: {
    base: "absolute h-8 w-8 rounded-full",
    previousHorizontal: "-left-12 top-1/2 -translate-y-1/2",
    previousVertical: "-top-12 left-1/2 -translate-x-1/2 rotate-90",
    nextHorizontal: "-right-12 top-1/2 -translate-y-1/2",
    nextVertical: "-bottom-12 left-1/2 -translate-x-1/2 rotate-90",
    icon: "h-4 w-4",
  },
} as const;
